import React from 'react';
import { Button } from 'antd';
import PropertyGrid from '../PropertyGrid';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";


export default class PropertyGridEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    setRef(ref) {
        if (this.ref || !ref)
            return;

        this.ref = ref;
    }

    render() {

        return (
            <PropertyGrid ref={ref => this.setRef(ref)} source={this.props.source.value} propertyGrid={this.props.propertyGrid} ></PropertyGrid>
        );
    }
}

PropertyGridUtils.register("propertygrid", (source, propertyGrid) => <PropertyGridEditor source={source} propertyGrid={propertyGrid} />);